import { get } from 'lodash';
import React, { FC } from 'react';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { useApplication } from 'src/context/ApplicationContext';
import { ANTRAGS_FORMULAREN, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';

// import schemas
import MittelabrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import AbschlussMaEpz from '../../../epz/content/AbschlussMaEpz';
import AbschlussMaKreativ from '../../../kreativ/content/AbschlussMaKreativ';
import AbschlussMaLoewe from '../../../loewe/content/AbschlussMALoewe';
import AbschlussMaStipendium from '../../../stipendium/content/AbschlussMAStipendium';
const MA_P = MittelabrufSchema.attributes;

const MAAngabenPruefen: FC<{ untertitel: string; inhalt: string }> = ({ untertitel, inhalt }) => {
	const { application } = useApplication();

	const RenderUebersichtTabelle: FC<{}> = () => {
		const antragsFormular = get(application, MA_P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path, '');
		switch (antragsFormular) {
			case ANTRAGS_FORMULAREN.Entwicklungszusammenarbeit:
				return <AbschlussMaEpz />;
			case ANTRAGS_FORMULAREN.Kreativwirtschaft:
				return <AbschlussMaKreativ />;
			case ANTRAGS_FORMULAREN.StartUpStipendium:
				return <AbschlussMaStipendium />;
			case ANTRAGS_FORMULAREN.Loewe:
				return <AbschlussMaLoewe />;
			default:
				return <></>;
		}
	};
	return (
		<>
			<ApplicationHeading title={untertitel} description={PLATZHALTER_TEXT} />
			<MarkdownRenderer markdown={inhalt} />

			<RenderUebersichtTabelle />
		</>
	);
};

export default MAAngabenPruefen;
